import Model from '@/lib/data/Model';
import FormRow from './FormRow';

class Survey extends Model {
    fields = [
        'name',
        'id',
        {
            name: 'values',
            association: {
                type: 'many',
                model: FormRow,
            },
        },
    ];

    /**
     * Create the Survey object
     *
     * @param {Object} data - Seed data for this object.
     */
    constructor(data) {
        super(data);
        this.init();
    }
}

export default Survey;
